import React, { useId } from 'react';
import { CgFilterSelect } from 'modules/Common/ui/CgFilterDropdown';
import { useTranslation } from 'react-i18next';

// Items-per-page picker for the shared table pagination bar. Renders on
// CgFilterSelect (Radix popover) so it matches the app's dropdowns instead of
// the browser's native <select>. Contract unchanged: `options` is an array of
// numbers, `onChange` receives the picked value (callers parseInt it).
export default function MaxPageResultsSelect({ options = [], value, onChange }) {
  const { t } = useTranslation('common');
  const id = useId();
  return (
    <div className="flex items-center gap-2">
      <label
        htmlFor={id}
        className="m-0 text-sm font-semibold text-slate-500 whitespace-nowrap"
      >
        {t('common:pagination.itemsPerPage', 'Items per page')}
      </label>
      <div className="w-20">
        <CgFilterSelect
          id={id}
          options={options.map((opt) => ({ value: opt, label: String(opt) }))}
          value={value ?? null}
          onChange={(val) => {
            // Ignore clears — a page size is always set.
            if (val != null) onChange(val);
          }}
          searchable={false}
          isClearable={false}
        />
      </div>
    </div>
  );
}
